import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersDelete } from '../../../adminSlice';

export default class DeleteInputFormsForAnswers  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const {dispatch } = this.props;

        const item = {
            answer_id: this.props.adminState.selectedId,
            sortQuestion: Number(this.props.adminState.sortQuestion),
            
        }
        console.log(item);
        dispatch(idAnswersDelete(item));  
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
   // let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForAnswers) {
        return(
            <div className="InputFormsForQuizes">
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Ответ: {this.props.adminState.dataAnswersId.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.text;} else return null;
                })}
                </p>
                


             <p>Вы действительно хотите удалить данный ответ?</p>
             
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}